module.exports = __webpack_public_path__ + "static/7import-794756ee004b3fbc5d59b00b23ce418b.png";